import { useQuery } from '@tanstack/react-query';
import { NOTAS_FISCAIS_KEYS, listarNotasFiscais } from '../../notas-fiscais/api';

interface DashboardParams {
  companyId?: string;
  collaboratorId?: string;
}

export function useDashboardNotas(params?: DashboardParams) {
  return useQuery({
    queryKey: NOTAS_FISCAIS_KEYS.list(params),
    queryFn: () => listarNotasFiscais(params),
  });
}
